// Manage DSR custom page accessibility
export const MANAGE_DSR_CUSTOM_PAGES_ACCESSIBILITY_REQUEST = 'manage_dsr_custom_pages_accessibility_request';
export const MANAGE_DSR_CUSTOM_PAGES_ACCESSIBILITY_SUCCESS = 'manage_dsr_custom_pages_accessibility_success';
export const MANAGE_DSR_CUSTOM_PAGES_ACCESSIBILITY_FAILURE = 'manage_dsr_custom_pages_accessibility_failure';
export const MANAGE_DSR_CUSTOM_PAGES_ACCESSIBILITY_RESET = 'manage_dsr_custom_pages_accessibility_reset';